import type { RouteRecordRaw } from 'vue-router'

const notesRoutes: RouteRecordRaw = {
  path: '/notes',
  name: 'notes',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.notes' },
  component: () => import('@/pages/notes/NotesPage.vue'),
}

export default notesRoutes
